import React from 'react';

import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';

import { HeaderNoData } from '@src/containers/header';

import { FooterNoData } from '@src/components/footer';

import '@src/containers/app.scss';

const EmptyPage = ({ children }) => (
    <Container fluid id="app" className="app px-0">
        <HeaderNoData />
        <div className="app-main-content-container px-3">
            { children }
        </div>
        <FooterNoData />
    </Container>
);

EmptyPage.propTypes = {
    children: PropTypes.node.isRequired,
};

export default EmptyPage;

